import React from 'react';
import { useStars } from './StarContext';
import { Button, Col, Card, Row } from 'react-bootstrap';

function Season2() {
  const { sezon2 } = useStars();

  return (
    <Row>
      {sezon2 && sezon2.map((item, index) => (
        <Col md={4} key={index} className="mb-4">
          <Card className="bg-dark text-white">
            <Card.Img
              variant="top"
              src={`/image/${item.image}`}
            />
            <Card.Body>
              <Card.Title>{item.title}</Card.Title>
              <Card.Text>{item.description}</Card.Text>
              <Button href={`/season_2/${item.episode}`}>
                Episode {item.episode}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default Season2;
